var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DialogLayout", {
    attrs: { title: "新規追加", visible: _vm.dialogVisible, width: "40em" },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      open: _vm.open
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function() {
          return [
            _c("TakeoffPassengersDataForm", {
              ref: "takeoffPassengersDataForm",
              attrs: {
                "label-width": "10em",
                formMode: "register",
                billingYmMode: "input",
                "autocomplete-airport-code-set": _vm.autocompleteAirportCodeSet,
                "autocomplete-customer-code-set":
                  _vm.autocompleteCustomerCodeSet
              },
              model: {
                value: _vm.takeoffPassengersDataFormModel,
                callback: function($$v) {
                  _vm.takeoffPassengersDataFormModel = $$v
                },
                expression: "takeoffPassengersDataFormModel"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c("RegisterDialogFooter", {
              on: { clear: _vm.clickClear, register: _vm.clickRegister }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }